export default __webpack_public_path__ + "static/thanks-7010dee69355130565260a043e1b80d6.png";